{
  "application": {
    "environment": "production"
  },
  "brand": "profitroll",
  "caPub": "",
  "gaApiKey": "",
  "backendUrl": "https://api.profitroll.com.ua",
  "_backendUrl": "http://localhost:8000",
  "sentryDsn": "",
  "sentrySendPii": false,
  "sentryTracesSampleRate": 0.1,
  "amplitudeApiKey": "",
  "imageSource": "https://imagedelivery.net/8CA2tdaqNe_KDNIRc5st7Q",
  "firebaseConfig": {
    "apiKey": "AIzaSyDyZkdv5R005sxghWQ8ggNZ-atgxnJM1cM",
    "authDomain": "job-atlas-auth.firebaseapp.com",
    "projectId": "job-atlas-auth",
    "storageBucket": "job-atlas-auth.firebasestorage.app",
    "messagingSenderId": "303497845514",
    "appId": "1:303497845514:web:99b5aa330a678eabaa38f3",
    "measurementId": "G-34HR0F88J2"
  }
}
